import { FormHelperText } from "@material-ui/core";
import React, { Component } from "react";
import Button from "../../FormElement/Button";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";


class ResetPasswordForm extends Component {
  state = {
    resetPassword: {
      password: "",
      conformPassword: ""
    },
    formErrors: {
      password: "",
      conformPassword: ""
    },
    isInvalid: true,
    successMessage: false
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      prevState => {
        return {
          resetPassword: {
            ...prevState.resetPassword,
            [name]: value
          }
        };
      },
      () => {
        const { resetPassword } = this.state;
        this.validateAll(resetPassword);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { resetPassword } = this.state;
        this.validateAll(resetPassword);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  validateResetForm = () => {
    const { password, conformPassword } = this.state.resetPassword;
    if (conformPassword !== "" || conformPassword !== null)
      return password === conformPassword;
    else return true;
  };

  handleSubmit = () => {
    this.validateResetForm();
    this.setState({ isInvalid: true });
    const formData = { ...this.state.resetPassword };
    this.props.handleSubmit(formData);
  };

  render() {
    const { resetPassword, isInvalid } = this.state;
    return (
      <div className="">
        <div className="mainform">
          <p className="loginHeader">Choose a new password</p>
          <InputFiled
            value={resetPassword.password}
            label="Password"
            type="password"
            name="password"
            required
            validations={["password", "required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
          />
          <InputFiled
            value={resetPassword.conformPassword}
            label="Confirm Password"
            type="password"
            name="conformPassword"
            required
            validations={["required"]}
            handleChange={this.handleChange}
            handleError={this.handleError}
          />
          {!this.validateResetForm() && (
            <FormHelperText>
              <span className="error" role="alert">
                Your password confirmation did not match your password
              </span>
            </FormHelperText>
          )}
          <div className="signInSection">
            <Button
              disabled={isInvalid || !this.validateResetForm()}
              name="Reset password"
              styleClass="signIn"
              onclick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/components/public/ForgotPassword/ResetPasswordForm.js